import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const connectionString = `InstrumentationKey=${import.meta.env.VITE_INSTRUMENTATION_KEY};IngestionEndpoint=${import.meta.env.VITE_INSIGHTS_URL}`;

const applicationInsightsPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: connectionString,
    extensions: [applicationInsightsPlugin as any],
    disableAjaxTracking: true,
    disableFetchTracking: true,
    disableExceptionTracking: false,
  },
});

// Don't load the AppInsights if the connection string will not be valid
if (
  import.meta.env.VITE_INSTRUMENTATION_KEY &&
  import.meta.env.VITE_INSTRUMENTATION_KEY.trim() !== "" &&
  import.meta.env.VITE_INSIGHTS_URL &&
  import.meta.env.VITE_INSIGHTS_URL.trim() !== ""
) {
  appInsights.loadAppInsights();
}

export { applicationInsightsPlugin };
